






























































import { Component, Vue, Emit } from 'vue-property-decorator'
import { QueryGoodsByCodee, QueryAllShopNameList, QuerySupplierList } from '@/api'
import { ElForm } from 'element-ui/types/form'
import { getByParentId } from '@/store/classifyStore'
import { VImageUpload } from '@/components/upload'
import {getUser} from '@/store/userStore'

@Component({
  components: {
    VImageUpload,
  },
})
export default class DescGoodsDialog extends Vue {
  private show = false
  private goodsBannersGileList: Array<any> = []
  private goodsDescImgsGileList: Array<any> = []
  private data = {
    goodsBannersGileList: this.goodsBannersGileList,
    goodsDescImgsGileList: this.goodsDescImgsGileList,
    goodsBanners: '',
    goodsDescImgs: '',
    settlementAmount: 0,
    salesIntegral: 0,
    preferentialIntegral: 0,
    rewardIntegral: 0,
  }
  private requiredRule = { required: true, message: '不能为空', trigger: 'blur' }
  private rules = {
    supplierCode: [this.requiredRule],
    goodsName: [this.requiredRule],
    goodsUnit: [this.requiredRule],
    salesIntegral: [this.requiredRule],
  }
  private supplierOption: Array<any> = []
  private shopIdOption: Array<any> = []

  private  userInfo = getUser()

  private classifyTree(parentId: number) {
    return getByParentId(parentId)
  }

  public async created() {
    await this.loadSupplier()
    this.loadShop()
  }

  private async loadShop() {
    const res = await QueryAllShopNameList({})
    const list = res.list
    this.shopIdOption = list.map((e: any) => {
      return { value: e.id, label: e.name }
    })

  }

  private async loadSupplier(){
     const res = await QuerySupplierList({})
    const list =  res.list
    this.supplierOption = list.map((e: any)=>{
      return {value: e.supplierCode,label:e.supplierSimpleName}
    })
  }

  @Emit('close')
  private close() {
    const f = this.$refs.form as ElForm
    f.resetFields()
    this.show = false
    this.data = {
      goodsBannersGileList: [],
      goodsDescImgsGileList: [],
      goodsBanners: '',
      goodsDescImgs: '',
      settlementAmount: 0,
      salesIntegral: 0,
      preferentialIntegral: 0,
      rewardIntegral: 0,
    }
  }
  public async open(goodsCode: string) {
    this.show = true
    const result = await QueryGoodsByCodee({ goodsCode })
    this.data = result
    if (this.data.goodsBanners) {
      this.data.goodsBannersGileList = this.data.goodsBanners.split(',').map((e: string) => {
        return { url: e }
      })
    }
    if (this.data.goodsDescImgs) {
      this.data.goodsDescImgsGileList = this.data.goodsDescImgs.split(',').map((e: string) => {
        return { url: e }
      })
    }
    this.data.settlementAmount = this.data.settlementAmount / 100
    this.data.salesIntegral = this.data.salesIntegral / 100
    this.data.preferentialIntegral = this.data.preferentialIntegral / 100
    this.data.rewardIntegral = this.data.rewardIntegral / 100
  }

  public async save() {
    this.close()
  }
}
